import gates from './gates'
import permissions from './permissions'

export default {
  fields: {
    gates,
    permissions,
  },
}
